import { useEffect } from "react";
import * as React from "react";

import { OpenInNew } from "@livechat/design-system-icons";
import { Button, Icon } from "@livechat/design-system-react-components";

import Block from "components/layout/Block";
import Text from "components/layout/Text";
import { config } from "config/config";
import { EventPlace, trackEngagement } from "helpers/analytics";
import ApplicationSettingsContainer from "routes/settings/integrations/components/ApplicationSettingsContainer";
import { ContentWrapper, PageWrapper } from "routes/settings/styled";

const ZapierSettings: React.FC = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://zapier.com/apps/embed/widget.js?services=helpdesk&html_id=zapier-container";
    script.async = true;
    document.body.appendChild(script);

    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleOpenZapierClick = () => {
    trackEngagement("Zapier integration: Open Zapier button clicked", EventPlace.Settings);
  };
  useEffect(() => {
    trackEngagement("Settings: App details opened", EventPlace.Settings, {
      appName: "zapier",
    });
  }, []);

  return (
    <ApplicationSettingsContainer title="Zapier">
      <PageWrapper>
        <ContentWrapper>
          <h2>Zapier integrations</h2>

          <Text marginBottom="12px" fontSize="14px" lineHeight="21px">
            Connect HelpDesk with other applications and automate your rules with Zapier.
          </Text>

          <Button
            href={config.zapierLink}
            target="_blank"
            rel="nofollow noreferrer noopener"
            size="compact"
            iconPosition="right"
            icon={<Icon source={OpenInNew} />}
            onClick={handleOpenZapierClick}
          >
            Open Zapier
          </Button>

          <Block marginTop="32px" id="zapier-container" />
        </ContentWrapper>
      </PageWrapper>
    </ApplicationSettingsContainer>
  );
};

export default ZapierSettings;
